module.exports = __webpack_public_path__ + "static/media/Collaboration.9470e983.png";